export const paletas = {
  White: "#fff",
  Black: "#000",
  RedTheme: "#d13639",
  RedLight: "#ff4040",
  Grafite: "#2e2e2e",
  Grafite25: "#3a3a3a",
  Grafite75: "#252525",
  GreenMunsell: "#04A777",
  DarkOrange: "#ffa940",
  DarkPurple: "#291720",
  BlueLight: "#4db2ff",
  OrangeVivid: "#ff6632",
  OrangeDesaturado: "#ce9178",
  Gold: "#FFD700",
  Lightyellow: "#FFFFE0",
};

export const darkTheme = {
  background: paletas.Grafite,
  text: paletas.DarkOrange,
};

export const lightTheme = {
  background: paletas.DarkOrange,
  text: paletas.Grafite,
};
